import file from "../Markdown/FAQ.md";
import React from "react";
import MarkdownPage from "../Layout/MarkdownPage";

function FAQ() {
    return (<MarkdownPage title='Centrum Pomocy' file={file} />);
}

export default FAQ;